'use strict';

(function (global) {
  /**
  * Drag & drop для списка объектов проводника
  * @namespace Core.objectList.dragging
  * @since 5.1.0.1523
  */
  global.dragging = class {
    constructor() {
      /** 
       *@property {string} draggable селектор для обновления дерева
       *@property {object} JDraggable перетаскиваемые объекты
       *@property {boolean} isCopyKeyPressed кнопка копирования нажата
       *@property {boolean} isCancelKeyPressed кнопка отмены нажата
       */
      this.draggable = '.List';
      this.jDraggable = null;
      this.isCopyKeyPressed = false;
      this.isCancelKeyPressed = false;
      this.overlayElement = `<div id="dnd_overlay"><div id="dnd_overlay_info">${L('PLACE_FILES_HERE')}</div></div>`;
      this.selector = 'body';
      this.overlaySelector = '#dnd_overlay';
      this.overlayInfoSelector = '#dnd_overlay_info';
      this.jDndOverlay = $(this.overlaySelector);
      this.jDndOverlayInfo = $(this.overlayInfoSelector);

      if (WA.ENV.isTouch()) {
        log.info('DRAG&DROP', 'Drag & Drop is disabled for touch devices');
        return;
      }
      log.info('DRAG&DROP', 'Drag & Drop initializing');
      const loc = WA.getLocation();
      if (!(loc === 'task' || loc === 'job')) {
        this.initEvents();
      }
      this.refreshObjects();
      this.dragSetup()
        .dropSetup()
        .enableCopyButton();
      WA.ObjectListInit.done(() => {
        WA.CR.objectList.bind('itemsChange', () => {
          this.refreshObjects()
            .enableCopyButton()
            .dragSetup()
            .dropSetup();
        });
      });
    }

    /**
    * Обновить jquery объекты, когда обнвовляется дерево
    * @function Core.objectList.dragging.refreshObjects
    * @since 5.1.0.1523
    * @return {Core.folderTree.dragAndDrop}
    */
    refreshObjects() {
      this.jDraggable = $(this.draggable).not('drag_binded');
      return this;
    }

    /**
    * При нажатии на CTRL при переносе должно происходить копирование ссылок
    * а не перенос.
    * @function Core.objectList.dragging.enableCopyButton
    * @since 5.1.0.1523
    * @return {Core.objectList.dragging}
    */
    enableCopyButton() {
      this.jDraggable.bind('drag keydown', Core.dropping.enableCopyButton);
      return this;
    }

    /**
    * Настройка элементов, которые можно перетаскивать
    * Здесь же в функции helper формируется представление переносимого
    * объекта.
    * @function Core.objectList.dragging.dragSetup
    * @since 5.1.0.1523
    * @return {Core.objectList.dragging}
    * @see #91763
    * @see #93576
    * @see http://goo.gl/QIkKPS
    */
    dragSetup() {
      const MaxVisuallyStackedObjects = 3;

      const settings = {
        helper() {
          const jObject = $(this);

          const jAttachedToCursorItem = $('<div class="movedStack"></div>');
          if (!jObject.hasClass('selected')) WA.CR.objectList.selectItemByID(jObject.attr('id'));

          var count = WA.CR.objectList.getSelectedItems().length;
          if (count == 1) jObject.addClass('lastDrag');

          for (var i = 1; i < count && i < MaxVisuallyStackedObjects; i++) {
            jAttachedToCursorItem.prepend('<div class="object-list-item_stacked"></div>');
          }
          jAttachedToCursorItem.append($(this).clone().addClass('movedItem'));

          return jAttachedToCursorItem;
        },

        revert: 'invalid',
        cursorAt: { left: 13, top: 13 },
        cursor: 'grabbing',
        distance: 10,
        cancel: '.fastActions',
      }

      this.jDraggable.draggable(settings).addClass('drag_binded');
      return this;
    }

    /**
    * Настройка элементов, В(!) которые можно перетаскивать
    * @function Core.folderTree.objectList.dropSetup
    * @since 5.1.0.1523
    * @return {Core.folderTree.objectList}
    */
    dropSetup() {
      Core.dropping.init();
      return this;
    }

    createOverlay() {
      if (!$(this.overlaySelector).length) {
        $(this.selector).prepend(this.overlayElement);
      }
      this.jDndOverlay = $(this.overlaySelector);
      this.jDndOverlayInfo = $(this.overlayInfoSelector);
      this.jDndOverlay.bind('dragleave', () => {
        this.jDndOverlay.removeClass('backgroundDragAndDrop');
        this.jDndOverlayInfo.css('display', 'none');
      });
    }

    initEvents() {
      if (!$(this.overlaySelector).length) {
        const loc = WA.getLocation();
        if (loc === 'task' || loc === 'job') {
          this.selector = '#Attachments_AttachmentsList_list';
          $(this.selector).css('height', '100%');
        } else if (loc === 'explorer') {
          this.selector = '#main_container';
        }

        if (
          ((loc === 'doc' || loc === 'reference') && GetParamInURL('view') == 'BoundDocuments') ||
          ((loc === 'task' || loc === 'job') && (GetParamInURL('mode') === 'edit' ||
            (WA.CR.toolBar.buttons.TaskChange && WA.CR.toolBar.buttons.TaskChange.isSelected()))) ||
          (loc === 'explorer')
        ) {
          $(this.selector).bind('dragover', e => {
            if (!$(this.dialogSelector).length) {
              this.createOverlay();
              const loc = WA.getLocation();

              this.jDndOverlay.addClass('backgroundDragAndDrop');
              this.jDndOverlayInfo.css('display', 'table-cell');
              if ((e.originalEvent) && (e.originalEvent.dataTransfer)) {
                e.originalEvent.dataTransfer.dropEffect = 'copy';
              }
              if (loc === 'task' || loc === 'job') {
                this.jDndOverlay.css('position', 'relative');
              } else if (loc === 'explorer') {
                this.jDndOverlay.css({
                  position: 'absolute',
                  height: $('#scroller')[0].scrollHeight
                });
              } else {
                this.jDndOverlay.css('position', 'fixed');
              }
            }
            return false;
          }).bind('drop', e => {
            if (!$(this.dialogSelector).length) {
              let showCreateDialog = true;
              this.jDndOverlay.trigger('dragleave');

              e = (e && e.originalEvent ? e.originalEvent : window.event) || e;
              if (e.preventDefault) {
                e.preventDefault();
              }
              const kind = e.target.getAttribute('kind');
              if (!e.target.closest('.tree__node-content') && (kind === null || kind === 'att')) {
                let dirDropped = false;
                const droppedItems = (e.items || e.dataTransfer.items);
                if (droppedItems) {
                  dirDropped = $(droppedItems).toArray().some(droppedItem => droppedItem.webkitGetAsEntry().isDirectory);
                }
                if (dirDropped) {
                  new WA.CMP.dialogs.MessageBox().showInfo(L('COULD_NOT_UPLOAD_FOLDER'));
                  showCreateDialog = false;
                } else {
                  const files = (e.files || e.dataTransfer.files);
                  if (files.length) {
                    // когда files.length == 0, значит либо дропнули папку, либо что-то пошло не так
                    let totalSize = 0;
                    const fileNames = [];
                    for (let file of files) {
                      totalSize += file.size;
                      fileNames.push(file.name);
                    }
                    if (totalSize > window.MaxRequestLength) {
                      let dialogTitle = L('ERR_CREATE_EDOC');
                      if (files.length > 1) {
                        dialogTitle = L('ERR_CREATE_EDOCUMENTS');
                      }
                      new WA.CMP.dialogs.MessageBox().showError(dialogTitle, L('ERR_TOTAL_FILE_SIZE_BIG'));
                      showCreateDialog = false;
                    }
                    const args = {
                      FileNames: fileNames,
                    };
                    WA.SRV.callSync('EDocument.asmx/GetUnsupportedFileNames', args).done(res => {
                      if (res) {
                        let dialogTitle = L('ERR_CREATE_EDOC');
                        if (files.length > 1) {
                          dialogTitle = L('ERR_CREATE_EDOCUMENTS');
                        }
                        new WA.CMP.dialogs.MessageBox().showWarning(dialogTitle, L('EDOC_EDITOR_NOT_FOUND', `${res}`));
                        showCreateDialog = false;
                      }
                    });
                    if (!showCreateDialog) {
                      return false;
                    } else {
                      const mass = files.length > 1;
                      const dialog = new WA.CMP.dialogs.MassCreateDocument();
                      dialog.fileList = files;
                      dialog.show(fileNames);
                      dialog.bind('loaded', () => {
                        if (mass) {
                          //Скрываем приложение редактор, если перетаскиваем несколько документов
                          $('#new_div_app').hide();
                          $('#isNeedToChangeApp').val(true);
                        } else {
                          $('#new_div_list').hide();
                          let name = files[0].name;
                          $(`<label title="${name}" class="filename">${name}<label />`).appendTo('#new_FileArea');
                          $('#edoc_vid').text(`*${L('EDOCUMENT_CREATE_VID_LABEL')}:`);
                          $('#edoc_type').text(`*${L('EDOCUMENT_CREATE_CARD_TYPE_LABEL')}:`);
                          $('#edoc_files').text(`*${L('FILE_NAME')}:`);
                        }
                        const location = WA.getLocation();
                        if (location === 'task' || location === 'job') {
                          // Изменяем имя папки за имя ЗЗУ, в которую будет вставлен документ.
                          $('#pasteInLabel').text(L('ATTACH_IN'));
                          $('#new_FolderNameTextBlock').text($('.card-header__label').text().trunc(50));
                        } else if (location === 'doc') {
                          $('#pasteInLabel').text(L('BIND_TO'));
                          WA.FC.eDocuments.getDocumentByID(WA.CR.ID).done(doc => $('#new_FolderNameTextBlock')[0].innerHTML = doc.Name.trunc(50));
                        } else if (location === 'reference') {
                          $('#pasteInLabel').text(L('BIND_TO'));
                          $('#new_FolderNameTextBlock').text($('.card-header__label').text().trunc(50));
                        }
                        dialog.showHelpIcon(false, 'MassNewDoc');
                      });
                      dialog.bind('open', res => {
                        //Установка приложения редактора
                        const re = new RegExp('.*\\.([^.]*)', 'gi');
                        const m = re.exec(files[0].name);
                        ext = m != null ? m[1] : '';
                        const extensionInfo = GetImgByExt(ext);
                        $('#refApp').SetValue(['' + extensionInfo.analit, $('<div/>').html(extensionInfo.name).text(), extensionInfo.name, '{}']);
                      });
                      dialog.bind('create', res => {
                        const location = WA.getLocation();
                        const links = [];
                        res.forEach((item) => {
                          const url = item.toURL();
                          if (location === 'task' || location === 'job') {
                            url.setParam('mode', 'new');
                            url.setParam('cwid', WA.CR.getID());
                            url.setParam('cwtype', WA.getLocation());
                          } else if (location === 'reference' || location === 'doc') {
                            url.setParam('parentId', WA.current.ID);
                            url.setParam('mode', 'new');
                          } else if (location === 'explorer') {
                            url.setParam('folder', item.folder);
                            url.setParam('mode', 'new');
                          }
                          links.push({ ID: item.id, Kind: 'EDoc', CompCode: '' });
                          url.open();
                        });
                      });
                      dialog.bind('error', res => {
                        log.error(res);
                      });
                    }
                  }
                }
              }
            }
          });
        }
      }
    }
  }


})(window.Core.objectList);


